module.exports = __webpack_public_path__ + "media/game_bg_old.669db27d.mp4";